import {
  STORE_FORM_REQUEST,
  STORE_FORM_SUCCESS,
  STORE_FORM_FAILURE,
  UPLOAD_FILE_REQUEST,
  UPLOAD_FILE_DELETE,
  UPLOAD_FILE_UPLOADING,
  UPLOAD_FILE_SUCCESS,
  UPLOAD_FILE_FAILURE,
  UPDATE_ADDRESS,
  LOAD_SERVICE_STATE,
  GET_QUOTE_REQUEST,
  GET_QUOTE_SUCCESS,
  GET_QUOTE_FAILURE,
  CHECK_MAPSHARE_REQUEST,
  CHECK_MAPSHARE_SUCCESS,
  CHECK_MAPSHARE_FAILURE
} from "../actions/types";

const initialState = {
  data: {},
  error: {},
  response: {},
  isPending: false,
  showThankyou: false,
  getQuote: false,
  mapShareData: true,
  quoteResponse: {},
  attachments: [],
  addresses: []
};

export const serviceReducer = (state = initialState, action = {}) => {
  let file, address, index;

  switch (action.type) {
    case LOAD_SERVICE_STATE:
      return action.payload
    case UPDATE_ADDRESS:
      address = state.addresses.find(address => (
        address.id === action.payload.id)
      );
      index = state.addresses.findIndex(a => (
        a === address));

      //found 
      if (address) {
        return {
          ...state, 
          addresses: [ 
            ...state.addresses.slice(0,index),
            Object.assign({}, state.addresses[index], {
              ...address, 
               value: action.payload.value,
               isSelected: action.payload.isSelected,
               isManual: action.payload.isManual,
               required: action.payload.required
            }),
            ...state.addresses.slice(index+1)
          ]
        }
      } else {
        return {
          ...state,
          addresses: [...state.addresses, {
            ...action.payload
          }]
        } 
      }
    case STORE_FORM_REQUEST:
      return Object.assign({}, state, {
        error: {},
        isPending: true
      });
    case STORE_FORM_SUCCESS:
      return Object.assign({}, state, {
        response: action.payload,
        error: {},
        isPending: false,
        showThankyou: true
      });
    case STORE_FORM_FAILURE:
      return Object.assign({}, state, {
        response: {},
        error: action.payload,
        isPending: false,
        showThankyou: false
      });   
    case UPLOAD_FILE_REQUEST:
      file = state.attachments.find(file => (
        file.originalFileName === action.payload.originalFileName &&
        file.fileSize === action.payload.fileSize &&
        file.id === action.payload.id)
      );
      
      index = state.attachments.findIndex(f => f === file);
      if (index === -1) return {
        ...state,
        attachments: [...state.attachments, {
          ...action.payload
        }]
      };

      return {
        ...state, 
        attachments: [ 
          ...state.attachments.slice(0,index),
          Object.assign({}, state.attachments[index], {
            ...file, 
            ...action.payload
          }),
          ...state.attachments.slice(index+1)
        ]
      }

    case UPLOAD_FILE_DELETE:
      return {
        ...state,
        attachments: state.attachments.filter(file => file.transactionID !== action.payload)
      }     
    case UPLOAD_FILE_UPLOADING:
      file = state.attachments.find(file => (
        file.originalFileName === action.payload.originalFileName &&
        file.fileSize === action.payload.fileSize &&
        file.id === action.payload.id)
      );    

      index = state.attachments.findIndex(f => f === file);
      if (index === -1) return;

      return {
        ...state, 
        attachments: [ 
          ...state.attachments.slice(0,index),
          Object.assign({}, state.attachments[index], {
            ...file, 
             isUploading: action.payload.isUploading,
             percentage: action.payload.percentage
          }),
          ...state.attachments.slice(index+1)
        ]
      }
    case UPLOAD_FILE_SUCCESS:
      file = state.attachments.find(file => (
        file.originalFileName === action.payload.originalFileName &&
        file.fileSize === action.payload.fileSize &&
        file.id === action.payload.id)
      );    

      index = state.attachments.findIndex(f => f === file);
      if (index === -1) return;

      return {
        ...state, 
        attachments: [ 
          ...state.attachments.slice(0,index),
          Object.assign({}, state.attachments[index], {
            ...file, 
            isUploading: action.payload.isUploading,
            attachmentURI: action.payload.attachmentURI,
            transactionID: action.payload.transactionID,
            percentage: action.payload.percentage
          }),
          ...state.attachments.slice(index+1)
        ]
      }      
    case UPLOAD_FILE_FAILURE:
      file = state.attachments.find(file => (
        file.originalFileName === action.payload.originalFileName &&
        file.fileSize === action.payload.fileSize &&
        file.id === action.payload.id)
      );    
      return {
        ...state, 
        attachments: [ ...state.attachments.filter(f => f !== file),
        { ...file, 
          isUploading: action.payload.isUploading,
          error: action.payload.error,
          percentage: action.payload.percentage
        }]
      }
    case GET_QUOTE_REQUEST:
      return Object.assign({}, state, {
        error: {},
        getQuote: true
      });
    case GET_QUOTE_SUCCESS:
      return Object.assign({}, state, {
        quoteResponse: action.payload,
        error: {},
        getQuote: false
      });
    case GET_QUOTE_FAILURE:
      return Object.assign({}, state, {
        quoteResponse: {},
        error: action.payload,
        getQuote: false
      });
      case CHECK_MAPSHARE_REQUEST:
      return Object.assign({}, state, {
        mapShareData: true
      });
    case CHECK_MAPSHARE_SUCCESS:
      return Object.assign({}, state, {
        mapShareData: true
      });
    case CHECK_MAPSHARE_FAILURE:
      return Object.assign({}, state, {
        mapShareData: false
      });
    default:
      return state;
  }
};